export type TipoParametro = 'ARQ_POSTAGEM_URI_PREAUTENTICADA' | 'APL_IB_HABILITA_SUPORTE' | 'MON_ANO_BASE_VIGENTE';

export class ConfigParametro {
  vl_parametro: string;
}
